/**
 * CSS custom properties emitted by the active theme's MuiCssBaseline (see theme.ts).
 *
 * They exist so that *static* style objects — ones that cannot read the theme through useTheme or a
 * makeStyles callback without turning into a per-instance dynamic stylesheet — still follow whichever
 * branding is active. Import these constants instead of writing the var name by hand, so the producer
 * in theme.ts and the consumers stay in sync.
 */
export const PALETTE_PRIMARY_MAIN_VAR = '--palette-primary-main';

/** `var()` reference to {@link PALETTE_PRIMARY_MAIN_VAR}, for use as a CSS value. */
export const palettePrimaryMain = `var(${PALETTE_PRIMARY_MAIN_VAR})`;
